import { CircleX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogDescription, DialogHeader, DialogTitle } from 'components/dialog/dialog';
import {
  CancelDialogContent,
  CancelDialogFooter,
  ConfirmCancelButton,
  KeepRecordingButton,
} from './CancelRecordingDialog.styles';

interface CancelRecordingDialogProps {
  isCancelling: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const CancelRecordingDialog = ({
  isCancelling,
  onConfirm,
  onClose,
}: CancelRecordingDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open onOpenChange={(open) => !open && !isCancelling && onClose()}>
      <CancelDialogContent data-ph-no-autocapture>
        <DialogHeader>
          <DialogTitle>{t('recording.cancelDialog.title')}</DialogTitle>
          <DialogDescription>{t('recording.cancelDialog.description')}</DialogDescription>
        </DialogHeader>
        <CancelDialogFooter>
          <KeepRecordingButton onClick={onClose} disabled={isCancelling}>
            {t('recording.cancelDialog.keep')}
          </KeepRecordingButton>
          <ConfirmCancelButton onClick={onConfirm} disabled={isCancelling}>
            <CircleX aria-hidden />
            {t('recording.cancelDialog.confirm')}
          </ConfirmCancelButton>
        </CancelDialogFooter>
      </CancelDialogContent>
    </Dialog>
  );
};
